import { Link } from 'react-router-dom';
import '../style/projects.scss';
import Loading from "../components/Loading";

import { useState, useEffect } from 'react';
import sanityClient from '../../client';
import NavAr from "./NavAr";
import FooterAr from "./FooterAr";

function ProjectsAr() {
  const [projectsData, setProjectsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const arabic = { direction: "rtl" };
  const [page, setPage] = useState(1);
  const [propCount, setPropCount] = useState(0);

  useEffect(() => {
    sanityClient.fetch(`count(*[_type=="projects"])`).then((data) => {
      setPropCount(data);
    });
    document.title = "امشاريع - CompanyName";
    document.querySelector("html").lang = "ar";
  }, []);

  useEffect(() => {
    
    let start = (page - 1) * 12;
    let end = start + 12;
    sanityClient
      .fetch(
        `*[_type=="projects"] | order(_createdAt desc) {
          "name": name.ar,
          "slug": Slug.current,
          "imgUrl" : images[0].asset->url
        }[${start}...${end}]`
      )
      .then((data) => {
        setProjectsData(data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, [page]);

  if (loading) {
    return <Loading />;
  }

  const pageTotal = Math.ceil(propCount / 12);
  const items = [];
  if (pageTotal !== 1) {
    for (let i = 1; i <= pageTotal; i++) {
      items.push(
        <span
          key={i}
          onClick={() => {
            setPage(i);
            window.scrollTo(0, 0);
          }}
        >
          {i}
        </span>
      );
    }
  }


  return (
    <>
     <NavAr url="/projects" />
    <div className="projects" style={arabic}>
      <header>
        <h1>المشاريع</h1>
      </header>
      <div className="all">
        {projectsData &&
          projectsData.map(({ name, slug, imgUrl }) => {
            return (
              <Project img={imgUrl} projectName={name} key={slug} slug={slug} />
            );
          })}
      </div>
      <div className="pagination">{items}</div>
    </div>
    <FooterAr />
    </>
  );
}

function Project({ img, projectName, slug }) {
  return (
    <div className="project">
      <Link to={'/ar/projects/' + slug}>
        <img src={img} alt={projectName} />

        <h3>{projectName}</h3>
      </Link>
    </div>
  );
}

export default ProjectsAr;
